"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSvg = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var rotate = /*#__PURE__*/(0, _styledComponents.keyframes)(["100%{transform:rotate(360deg);}"]);

var StyledSvg = /*#__PURE__*/_styledComponents["default"].svg.withConfig({
  displayName: "indexstyles__StyledSvg",
  componentId: "sc-81jxdp-0"
})(["width:", ";height:", ";margin-right:", ";animation:", " 0.75s linear infinite;fill:", ";"], function (p) {
  return p.theme.tokens.spacing06;
}, function (p) {
  return p.theme.tokens.spacing06;
}, function (p) {
  return p.theme.tokens.spacing04;
}, rotate, function (p) {
  return p.theme.colorTextLink;
});

exports.StyledSvg = StyledSvg;